import {
    SetSideNavOpenAction,
    SET_SIDE_NAV_OPEN
} from "../Types/SideNavActionTypes";

export const setSideNavOpen = (open: boolean): SetSideNavOpenAction => ({
    type: SET_SIDE_NAV_OPEN,
    data: open,
});
